import { z } from "zod";
import { isoDateOnlySchema } from "../common/date.js";
export const AVAILABILITY_CONFLICT_KINDS = ["booking", "external"];
export const availabilityConflictKindSchema = z.enum(AVAILABILITY_CONFLICT_KINDS);
export const AvailabilityConflictKindEnum = {
    BOOKING: "booking",
    EXTERNAL: "external",
};
export const availabilityConflictSchema = z.object({
    kind: availabilityConflictKindSchema,
    start: isoDateOnlySchema,
    end: isoDateOnlySchema,
    source_name: z.string().nullable(),
    summary: z.string().nullable(),
    reference_code: z.string().nullable(),
});
